module.exports = __webpack_public_path__ + "static/web-10-91209b3f2eb7fcabb286737be21a5bae.mp4";